import { ItemTypeConsts } from 'client/util/Constants';
import { featureFlags } from 'client/store/modules/FeatureFlagsModule';

const MdmMainPanel = () => import('client/MDM/MdmMainPanel.vue');

export default (enabledFlags) => {
  const component = [
    {
      path: '/mdm',
      beforeEnter: (to, from, next) => {
        next({ path: '/mdm/apple' });
      },
    },
    {
      path: '/mdm/apple',
      name: 'MdmMainPanel',
      meta: {
        title: 'MDM',
      },
      components: {
        mainPanel: MdmMainPanel,
      },
      props: {
        mainPanel: {
          gettingStartedPanelItemType: ItemTypeConsts.mdmSettings,
          itemType: ItemTypeConsts.mdmSettings,
          initialTabIndex: 0,
        },
      },
    },
  ];

  if (enabledFlags[featureFlags.windowsMdmEnrollment]) {
    component.push(
      {
        path: '/mdm/windows',
        name: 'MdmWindowsMainPanel',
        meta: {
          title: 'MDM',
        },
        components: {
          mainPanel: MdmMainPanel,
        },
        props: {
          mainPanel: {
            gettingStartedPanelItemType: ItemTypeConsts.mdmSettings,
            itemType: ItemTypeConsts.mdmSettings,
            initialTabIndex: 1,
          },
        },
      },
    );
  }

  if (enabledFlags[featureFlags.windowsMdmEnrollment] && enabledFlags[featureFlags.androidEmmMvp]) {
    component.push(
      {
        path: '/mdm/google',
        name: 'MdmGoogleMainPanel',
        meta: {
          title: 'MDM',
        },
        components: {
          mainPanel: MdmMainPanel,
        },
        props: {
          mainPanel: {
            gettingStartedPanelItemType: ItemTypeConsts.mdmSettings,
            itemType: ItemTypeConsts.mdmSettings,
            initialTabIndex: 2,
          },
        },
      },
    );
  }

  // eslint-disable-next-line max-len
  if (!enabledFlags[featureFlags.windowsMdmEnrollment] && enabledFlags[featureFlags.androidEmmMvp]) {
    component.push(
      {
        path: '/mdm/google',
        name: 'MdmGoogleMainPanel',
        meta: {
          title: 'MDM',
        },
        components: {
          mainPanel: MdmMainPanel,
        },
        props: {
          mainPanel: {
            gettingStartedPanelItemType: ItemTypeConsts.mdmSettings,
            itemType: ItemTypeConsts.mdmSettings,
            initialTabIndex: 1,
          },
        },
      },
    );
  }

  return component;
};
